import React, {FC} from 'react';
import styled from 'styled-components';

import {CardGroupPopoverContainer} from '../../../../../../../../src/components/common/createFormInputs/cardGroupPopoverContainer';
import {CardGroupModel} from '../../../../../../../../src/models/api/cardGroupModel';
import {Trans} from '../../../../../../../shared/helpers/src/internationalization/react';
import {HandlerOf} from '../../../../../../../shared/helpers/src/react/reactHelpers';

/*
 * Props.
 */

interface CreateContactCardGroupInputProps {
  cardGroupIds: ReadonlyArray<number>;
  namespace: string;
  isDisabled: boolean;
  onSelect: HandlerOf<CardGroupModel>;
  onRemove: HandlerOf<CardGroupModel>;
}

/*
 * Style.
 */

const StyledCardGroupPopoverContainer = styled(CardGroupPopoverContainer)`
  margin-top: 20px;
`;

/*
 * Component.
 */

export const CreateContactCardGroupInput: FC<CreateContactCardGroupInputProps> = (props) => {
  const {cardGroupIds, namespace, isDisabled, onSelect, onRemove} = props;
  return (
    <StyledCardGroupPopoverContainer
      isDisabled={isDisabled}
      cardGroupIds={cardGroupIds}
      title={<Trans id="create-contact-form-card-group-title">Lists</Trans>}
      namespace={namespace}
      onSelect={onSelect}
      onRemove={onRemove}
    />
  );
};
